module.exports = __webpack_public_path__ + "static/assets/a20b50b682cf1ef62f256073f9150e30.svg";